export default "__VITE_ASSET__DFoQVdDN__"